import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const AncillaryAnalysisLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: AncillaryAnalysis } = await import("@workflows/ancillaries/analysis");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_ANALYSIS}>
      <AncillaryAnalysis />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
